import { Controller, Control, FieldValues, UseFormWatch } from "react-hook-form";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { DefaultError } from "../DefaultError";
import styles from "./style.module.css";
import { AIAssistantButton } from "../ChatWidget";
import { QuestionType } from "../../models/QuestionTypeEnum";
import useAssistantStore, { AssistantStore } from "../../store/assistantStore";
import { linkifyHtml } from "../../helpers/linkifyHtml";
import moment from "moment";

interface IDateProps {
  control: Control<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  id: string | number;
  errors?: any;
  text: string;
  isAssistantActive: boolean;
}

export const DateItem = ({
  control,
  watch,
  id,
  errors,
  text = "",
  isAssistantActive,
}: IDateProps) => {
  const content = watch(`${id}`);

  const setInput = useAssistantStore(
    (state: AssistantStore) => state.setInput
  );
  if (isAssistantActive) {
    setInput({
      type: QuestionType.Date,
      data: content,
      value: content,
    });
  }

  return (
    <div className={styles.container}>
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: text ? linkifyHtml(text) : "",
          }}
        />
        <div className={"buttonContainer"}>
          <AIAssistantButton
            subQuestion={{ id: Number(id), text: text }}
          />
        </div>
      </div>
      <Controller
        name={`${id}`}
        control={control}
        defaultValue={null}
        render={({ field: { onChange, value } }) => (
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            inputVariant="outlined"
            format="DD/MM/YYYY"
            placeholder="DD/MM/AAAA"
            value={value ? moment(value) : null}
            onChange={(date) => {
              onChange(date ? date.format("YYYY-MM-DD") : "");
            }}
            autoOk
            fullWidth
            size="small"
            error={!!errors}
            invalidDateMessage="Data inválida"
            KeyboardButtonProps={{ "aria-label": "selecionar data" }}
          />
        )}
      />
      {errors && <DefaultError />}
    </div>
  );
};
